<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
  color: white;
  text-align: center;
}

.slider{
  padding: 0 20px;
}
</style>

<div class="bg">
  <div class="title-signup">What is your age preference for meeting other people?</div>
  
  <div class="margin slider">
    <RangeSlider id="price" min="{18}" max="{120}" pushy range float bind:values="{range}" springValues="{ { stiffness: 0.25, damping: 0.9 } }"></RangeSlider>
  </div>
  
  <div class="margin">{range[0]} - {range[1]}</div>

  <div class="has-buttons"></div>
  
</div>

<div class="next">
  <button on:click="{next}">Next</button>
</div>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import RangeSlider from "svelte-range-slider-pips";

let range = [18,120];

function next() {
  push("/signup/profile/personal/looking-for");
}


</script>